var levelOfAWSUsage = {
	"Level of AWS usage": "Niveau d'utilisation d'AWS",
	"Do not use AWS today": "N'utilise pas AWS pour le moment",
	"Evaluating/experimenting with AWS": "Évalue/teste actuellement AWS",
	"Run dev/test workloads on AWS": "Exécute des charges de travail de développement/test sur AWS",
	"Run a production workload on AWS": "Exécute une seule charge de travail de production sur AWS",
	"Run multiple production workloads on AWS": "Exécute plusieurs charges de travail de production sur AWS"
};

export { levelOfAWSUsage as default };
